import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import Photo from "./photo.avif";
import React from "react";
// Mobile imports
import Collagen1Mobile from "./images/carousel/Collagen-1.jpg";
import structuredClone from "@ungap/structured-clone";
// Desktop imports
import Collagen1Desktop from "./images/carousel/Collagen-1-1440.jpg";
import Collagen2Mobile from "./images/carousel/Collagen-2.jpg";
import Collagen2Desktop from "./images/carousel/Collagen-2-1440.jpg";
import Collagen3Mobile from "./images/carousel/Collagen-3.jpg";
import Collagen3Desktop from "./images/carousel/Collagen-3-1440.jpg";
import Collagen4Mobile from "./images/carousel/Collagen-4.jpg";
import Collagen4Desktop from "./images/carousel/Collagen-4-1440.jpg";
import Collagen5Mobile from "./images/carousel/Collagen-5.jpg";
import Collagen5Desktop from "./images/carousel/Collagen-5-1440.jpg";
import Creatine1Mobile from "./images/carousel/Creatine-1.jpg";
import Creatine1Desktop from "./images/carousel/Creatine-1-1440.jpg";
import Creatine2Mobile from "./images/carousel/Creatine-2.jpg";
import Creatine2Desktop from "./images/carousel/Creatine-2-1440.jpg";
import Creatine3Mobile from "./images/carousel/Creatine-3.jpg";
import Creatine3Desktop from "./images/carousel/Creatine-3-1440.jpg";
import Creatine4Mobile from "./images/carousel/Creatine-4.jpg";
import Creatine4Desktop from "./images/carousel/Creatine-4-1440.jpg";
import Creatine5Mobile from "./images/carousel/Creatine-5.jpg";
import Creatine5Desktop from "./images/carousel/Creatine-5-1440.jpg";
import Fiber1Mobile from "./images/carousel/Fiber-1.jpg";
import Fiber1Desktop from "./images/carousel/Fiber-1-1440.jpg";
import Fiber2Mobile from "./images/carousel/Fiber-2.jpg";
import Fiber2Desktop from "./images/carousel/Fiber-2-1440.jpg";
import Fiber3Mobile from "./images/carousel/Fiber-3.jpg";
import Fiber3Desktop from "./images/carousel/Fiber-3-1440.jpg";
import Fiber4Mobile from "./images/carousel/Fiber-4.jpg";
import Fiber4Desktop from "./images/carousel/Fiber-4-1440.jpg";
import Fiber5Mobile from "./images/carousel/Fiber-5.jpg";
import Fiber5Desktop from "./images/carousel/Fiber-5-1440.jpg";
// Mobile imports
import Hydration1Mobile from "./images/carousel/Hydration-1.jpg";
// Desktop imports
import Hydration1Desktop from "./images/carousel/Hydration-1-1440.jpg";
import Hydration2Mobile from "./images/carousel/Hydration-2.jpg";
import Hydration2Desktop from "./images/carousel/Hydration-2-1440.jpg";
import Hydration3Mobile from "./images/carousel/Hydration-3.jpg";
import Hydration3Desktop from "./images/carousel/Hydration-3-1440.jpg";
import Hydration4Mobile from "./images/carousel/Hydration-4.jpg";
import Hydration4Desktop from "./images/carousel/Hydration-4-1440.jpg";
import Hydration5Mobile from "./images/carousel/Hydration-5.jpg";
import Hydration5Desktop from "./images/carousel/Hydration-5-1440.jpg";
import Hydration6Mobile from "./images/carousel/Hydration-6.jpg";
import Hydration6Desktop from "./images/carousel/Hydration-6-1440.jpg";
import Protein1Mobile from "./images/carousel/Protein-1.jpg";
import Protein1Desktop from "./images/carousel/Protein-1-1440.jpg";
import Protein2Mobile from "./images/carousel/Protein-2.jpg";
import Protein2Desktop from "./images/carousel/Protein-2-1440.jpg";
import Protein3Mobile from "./images/carousel/Protein-3.jpg";
import Protein3Desktop from "./images/carousel/Protein-3-1440.jpg";
import Protein4Mobile from "./images/carousel/Protein-4.jpg";
import Protein4Desktop from "./images/carousel/Protein-4-1440.jpg";
import Protein5Mobile from "./images/carousel/Protein-5.jpg";
import Protein5Desktop from "./images/carousel/Protein-5-1440.jpg";
import Protein6Mobile from "./images/carousel/Protein-6.jpg";
import Protein6Desktop from "./images/carousel/Protein-6-1440.jpg";
import PW1Mobile from "./images/carousel/PW-1.jpg";
import PW1Desktop from "./images/carousel/PW-1-1440.jpg";
import PW2Mobile from "./images/carousel/PW-2.jpg";
import PW2Desktop from "./images/carousel/PW-2-1440.jpg";
import PW3Mobile from "./images/carousel/PW-3.jpg";
import PW3Desktop from "./images/carousel/PW-3-1440.jpg";
import PW4Mobile from "./images/carousel/PW-4.jpg";
import PW4Desktop from "./images/carousel/PW-4-1440.jpg";
import PW5Desktop from "./images/carousel/PW-5-1440.jpg";
import PW6Mobile from "./images/carousel/PW-6.jpg";
import ThumbLL from "./images/ll_thumb.png";
import ThumbMango from "./images/mango_thumb.png";
import ThumbSL from "./images/sl_thumb.png";
import ThumbWatermelon from "./images/watermelon_thumb.png";
import ThumbLemonGinger from "./images/lemonginger_thumb.jpg";
import ThumbPineapple from "./images/pineapple_thumb.jpg";
import GreensTp1Mobile from "./images/carousel/TropicalPineapple/GreensTP1/375-tp1.jpg";
import GreensTp1Desktop from "./images/carousel/TropicalPineapple/GreensTP1/1440-tp1.png";
import GreensTp2Mobile from "./images/carousel/TropicalPineapple/GreensTP2/375-tp2.jpg";
import GreensTp2Desktop from "./images/carousel/TropicalPineapple/GreensTP2/1440-tp2.jpg";
import GreensTp3Mobile from "./images/carousel/TropicalPineapple/GreensTP3/375-tp3.jpg";
import GreensTp3Desktop from "./images/carousel/TropicalPineapple/GreensTP3/1440-tp3.jpg";
import GreensTp4Mobile from "./images/carousel/TropicalPineapple/GreensTP4/375-tp4.jpg";
import GreensTp4Desktop from "./images/carousel/TropicalPineapple/GreensTP4/1440-tp4.jpg";
import GreensTp5Mobile from "./images/carousel/TropicalPineapple/GreensTP5/375-tp5.jpg";
import GreensTp5Desktop from "./images/carousel/TropicalPineapple/GreensTP5/1440-tp5.jpg";
import GreensLg1Mobile from "./images/carousel/LemonGinger/GreensLG1/375-lg1.jpg";
import GreensLg1Desktop from "./images/carousel/LemonGinger/GreensLG1/1440-lg1.png";
import GreensLg2Mobile from "./images/carousel/LemonGinger/GreensLG2/375-lg2.jpg";
import GreensLg2Desktop from "./images/carousel/LemonGinger/GreensLG2/1440-lg2.jpg";
import GreensLg3Mobile from "./images/carousel/LemonGinger/GreensLG3/375-lg3.jpg";
import GreensLg3Desktop from "./images/carousel/LemonGinger/GreensLG3/1440-lg3.jpg";
import GreensLg4Mobile from "./images/carousel/LemonGinger/GreensLG4/375-lg4.jpg";
import GreensLg4Desktop from "./images/carousel/LemonGinger/GreensLG4/1440-lg4.jpg";
import GreensLg5Mobile from "./images/carousel/LemonGinger/GreensLG5/375-lg5.jpg";
import GreensLg5Desktop from "./images/carousel/LemonGinger/GreensLG5/1440-lg5.jpg";
import Collagen from "Images/shop/plp/collagen.png";
import Creatine from "Images/shop/plp/creatine.png";
import Fiber from "Images/shop/plp/fiber.png";
import Hydration from "Images/shop/plp/hsnc001.png";
import Protein from "Images/shop/plp/plpprotein.png";
import PreWorkout from "Images/shop/plp/pwt02.png";
import Greens from "Images/shop/greens_hero.png";
// Arrays grouped by type and device
const collagenDesktop = [
    Collagen1Desktop,
    Collagen2Desktop,
    Collagen3Desktop,
    Collagen4Desktop,
    Collagen5Desktop,
];
const collagenMobile = [
    Collagen1Mobile,
    Collagen2Mobile,
    Collagen3Mobile,
    Collagen4Mobile,
    Collagen5Mobile,
];
const creatineDesktop = [
    Creatine1Desktop,
    Creatine2Desktop,
    Creatine3Desktop,
    Creatine4Desktop,
    Creatine5Desktop,
];
const creatineMobile = [
    Creatine1Mobile,
    Creatine2Mobile,
    Creatine3Mobile,
    Creatine4Mobile,
    Creatine5Mobile,
];
const fiberDesktop = [
    Fiber1Desktop,
    Fiber2Desktop,
    Fiber3Desktop,
    Fiber4Desktop,
    Fiber5Desktop,
];
const fiberMobile = [
    Fiber1Mobile,
    Fiber2Mobile,
    Fiber3Mobile,
    Fiber4Mobile,
    Fiber5Mobile,
];
// Arrays grouped by type and device
const hydrationDesktop = [
    Hydration1Desktop,
    Hydration2Desktop,
    Hydration3Desktop,
    Hydration4Desktop,
    Hydration5Desktop,
    Hydration6Desktop,
];
const hydrationMobile = [
    Hydration1Mobile,
    Hydration2Mobile,
    Hydration3Mobile,
    Hydration4Mobile,
    Hydration5Mobile,
    Hydration6Mobile,
];
const pwDesktop = [PW1Desktop, PW2Desktop, PW3Desktop, PW4Desktop, PW5Desktop];
const pwMobile = [PW1Mobile, PW2Mobile, PW3Mobile, PW4Mobile, PW6Mobile];
const greensTropicalPineappleMobile = [
    GreensTp1Mobile,
    GreensTp2Mobile,
    GreensTp3Mobile,
    GreensTp4Mobile,
    GreensTp5Mobile,
];
const greensTropicalPineappleDesk = [
    GreensTp1Desktop,
    GreensTp2Desktop,
    GreensTp3Desktop,
    GreensTp4Desktop,
    GreensTp5Desktop,
];
const greensLemonGingerMobile = [
    GreensLg1Mobile,
    GreensLg2Mobile,
    GreensLg3Mobile,
    GreensLg4Mobile,
    GreensLg5Mobile,
];
const greensLemonGingerDesk = [
    GreensLg1Desktop,
    GreensLg2Desktop,
    GreensLg3Desktop,
    GreensLg4Desktop,
    GreensLg5Desktop,
];
const proteinDesktop = [
    Protein1Desktop,
    Protein2Desktop,
    Protein3Desktop,
    Protein4Desktop,
    Protein5Desktop,
    Protein6Desktop,
];
const proteinMobile = [
    Protein1Mobile,
    Protein2Mobile,
    Protein3Mobile,
    Protein4Mobile,
    Protein5Mobile,
    Protein6Mobile,
];
export const PROTEIN = "PROTEIN";
export const PREWORKOUT = "PREWORKOUT";
export const HYDRATION = "HYDRATION";
export const COLLAGEN = "COLLAGEN";
export const CREATINE = "CREATINE";
export const FIBER = "FIBER";
export const GREENS = "GREENS";
export const PLANT_BASED = "PLANT_BASED";
export const WHEY_BASED = "WHEY_BASED";
export const LOW_LACTOSE = "LOW_LACTOSE";
export const KETOGENIC = "KETOGENIC";
export const LOSE_WEIGHT = "LOSE_WEIGHT";
export const GAIN_WEIGHT = "GAIN_WEIGHT";
export const BUILD_MUSCLE = "BUILD_MUSCLE";
export const MANGO = "MANGO";
export const SL = "SL";
export const LL = "LL";
export const WATERMELON = "WATERMELON";
export const LOW_SWEAT = "LOW_SWEAT";
export const HIGH_SWEAT = "HIGH_SWEAT";
export const LOW_STIM = "LOW_STIM";
export const MED_STIM = "MED_STIM";
export const HIGH_STIM = "HIGH_STIM";
export const CAF = "CAF";
export const DECAF = "DECAF";
export const VARIETY = "variety";
export const LEMONGINGER = "lemonginger";
export const PINEAPPLE = "tropicalpineapple";
// SKU Maps
export const proteinMap = {
    [`${WHEY_BASED}+${LOSE_WEIGHT}`]: "nm",
    [`${WHEY_BASED}+${GAIN_WEIGHT}`]: "ng",
    [`${WHEY_BASED}+${BUILD_MUSCLE}`]: "og",
    [`${PLANT_BASED}+${LOSE_WEIGHT}`]: "lv",
    [`${PLANT_BASED}`]: "gv",
    [`${PLANT_BASED}+${BUILD_MUSCLE}`]: "gv",
    [`${PLANT_BASED}+${GAIN_WEIGHT}`]: "gv",
    [`${LOW_LACTOSE}+${LOSE_WEIGHT}`]: "lr",
    [`${LOW_LACTOSE}`]: "gr",
    [`${LOW_LACTOSE}+${GAIN_WEIGHT}`]: "gr",
    [`${LOW_LACTOSE}+${BUILD_MUSCLE}`]: "gr",
    [`${KETOGENIC}`]: "kb",
    [`${KETOGENIC}+${LOSE_WEIGHT}`]: "kb",
    [`${KETOGENIC}+${GAIN_WEIGHT}`]: "kb",
    [`${KETOGENIC}+${BUILD_MUSCLE}`]: "kb",
};
export const hydrationMap = {
    [`${MANGO}+${LOW_SWEAT}+${CAF}`]: "low_caff_mango",
    [`${MANGO}+${LOW_SWEAT}+${DECAF}`]: "low_nocaff_mango",
    [`${MANGO}+${HIGH_SWEAT}+${CAF}`]: "high_caff_mango",
    [`${MANGO}+${HIGH_SWEAT}+${DECAF}`]: "high_nocaff_mango",
    [`${SL}+${LOW_SWEAT}+${CAF}`]: "low_caff_strawberrylemonade",
    [`${SL}+${LOW_SWEAT}+${DECAF}`]: "low_nocaff_strawberrylemonade",
    [`${SL}+${HIGH_SWEAT}+${CAF}`]: "high_caff_strawberrylemonade",
    [`${SL}+${HIGH_SWEAT}+${DECAF}`]: "high_nocaff_strawberrylemonade",
    [`${LL}+${LOW_SWEAT}+${CAF}`]: "low_caff_lemonlime",
    [`${LL}+${LOW_SWEAT}+${DECAF}`]: "low_nocaff_lemonlime",
    [`${LL}+${HIGH_SWEAT}+${CAF}`]: "high_caff_lemonlime",
    [`${LL}+${HIGH_SWEAT}+${DECAF}`]: "high_nocaff_lemonlime",
};
// four skus per flavor:
// - no caffeine (med stim + decaf)
// - no creatine (low stim + caf)
// - both, low stim (med stim + caf)
// - both, high stim (high stim + caf)
// here, low stim means no creatine and med stim means with creatine
// while high stim means with creatine, + more l-citrulline and beta-alanine
export const preworkoutMap = {
    [`${SL}+${MED_STIM}+${DECAF}`]: "decafstrawberrypw",
    [`${SL}+${LOW_STIM}+${CAF}`]: "nocreatinestrawberrypw",
    [`${SL}+${MED_STIM}+${CAF}`]: "lowstimstrawberrypw",
    [`${SL}+${HIGH_STIM}+${CAF}`]: "histimstrawberrypw",
    [`${WATERMELON}+${MED_STIM}+${DECAF}`]: "decafwatermelonpw",
    [`${WATERMELON}+${LOW_STIM}+${CAF}`]: "nocreatinewatermelonpw",
    [`${WATERMELON}+${MED_STIM}+${CAF}`]: "lowstimwatermelonpw",
    [`${WATERMELON}+${HIGH_STIM}+${CAF}`]: "histimwatermelonpw",
};
export const greensMap = {
    [LEMONGINGER]: "greens_lemonginger_28",
    [PINEAPPLE]: "greens_tropicalpineapple_28",
};
// question types
export const SELECTOR = "SELECTOR";
export const FLAVOR_BOOST_PICKER = "FLAVOR_BOOST_PICKER";
// copy
export const pageCopy = {
    [PROTEIN]: {
        bullets: [
            "Supports muscle growth and recovery",
            "Whey, Keto and Plant-based formulas to fit your dietary needs, without the bloat",
            "Up to 26g of protein per serving, depending on your blend",
        ],
        carouselDesktop: proteinDesktop,
        carouselMobile: proteinMobile,
        img: Protein,
        hed: "Customized Protein Powder",
        eyebrow: "Customize",
        dek: "Customize your protein to your specific needs. Whether you’re looking to bulk up or lose weight, build a protein that addresses your goals, diet, lifestyle and flavor preferences.",
        tape: ["20g+ of protein", "No fillers"],
        qty: (_jsxs("span", { children: ["14 servings", _jsx("br", {}), "per bag"] })),
        howToUse: "Add 1 scoop of Gainful Protein Powder to a blender bottle with 8 - 12 oz. of milk, milk-alternative, or water.  Mix in 1 delicious flavor boost and shake for 30 seconds. Gainful Protein Powder can be taken anytime throughout the day. On days you exercise, it’s most effective immediately following your workout to speed up recovery.",
    },
    [HYDRATION]: {
        bullets: [
            "Formulated with 4 key electrolytes to hydrate faster than water alone",
            "Only 2g of sugar, 9g less than other “big” brands and zero artificial flavors, sweeteners or dyes",
            "Caffeinated and non-caffeinated options to suit your hydration needs",
        ],
        carouselDesktop: hydrationDesktop,
        carouselMobile: hydrationMobile,
        img: Hydration,
        hed: "Customized Hydration",
        eyebrow: "Customize",
        dek: "Feel and perform your best with hydration formulas that deliver the right amount of electrolytes based on your caffeine preference, sweat levels and flavor.",
        tape: ["2g sugar", "Plant based", "Non-GMO"],
        qty: (_jsx("span", { children: "21 on-the-go-packs" })),
        howToUse: "Mix 1 packet of Gainful Hydration into 8 - 16oz of water and shake for 30 seconds. \n\nKickstart your morning with a glass, mix into your afternoon routine or drink after exercising to replenish your electrolytes.",
    },
    [PREWORKOUT]: {
        bullets: [
            "Formulated to fuel your workout and supercharge your recovery",
            "Caffeinated and non-caffeinated options for a jitter-free, clean energy boost at any time of day",
            "Less than 2g of sugar and zero artificial flavors, sweeteners or dyes",
        ],
        carouselDesktop: pwDesktop,
        carouselMobile: pwMobile,
        img: PreWorkout,
        hed: "Customized Pre-Workout",
        eyebrow: "Customize",
        dek: "Formulated to maximize endurance and minimize recovery time, customize your blend based on caffeine preference, exercise intensity and flavor.",
        tape: ["<1g sugar", "Plant based", "Non-GMO"],
        qty: (_jsxs("span", { children: ["14 servings", _jsx("br", {}), "per container"] })),
        howToUse: "Add 1 scoop of Gainful Pre-Workout into 6-12oz of water. Stir or shake for 30 seconds until all powder is dissolved. Take 20-30 minutes prior to exercising. Enjoy!",
    },
    [COLLAGEN]: {
        bullets: [
            "10g collagen per serving",
            "Supports healthy skin, joints, and connective tissues",
            "Formulated with 50mg of Vitamin C to boost your immune functions",
        ],
        carouselDesktop: collagenDesktop,
        carouselMobile: collagenMobile,
        img: Collagen,
        hed: "Grass Fed Collagen",
        eyebrow: "Formula Boost",
        dek: "Collagen is an easy-to-digest supplement that supports healthy skin, joints, and other connective tissues. Boost your Gainful Personalized Protein with a scoop of collagen.",
        tape: ["FIX", "ME"],
        qty: (_jsxs("span", { children: ["28 servings", _jsx("br", {}), "per container"] })),
        howToUse: "Mix 1 scoop of Collagen into your coffee, tea or Gainful Protein Powder. Consume daily for the best results.",
    },
    [CREATINE]: {
        bullets: [
            "Supports muscle strength and aids in recovery",
            "Proven to enhance cognitive functions such as memory, attention, and reasoning",
            "Mix this tasteless powder into any drink, daily",
        ],
        carouselDesktop: creatineDesktop,
        carouselMobile: creatineMobile,
        img: Creatine,
        hed: "Creatine Monohydrate",
        eyebrow: "Formula Boost",
        dek: "Creatine is a powerhouse amino acid that helps support muscle strength, short energy bursts and recovery. It has also been shown to support cognitive functions. Easily mix this tasteless powder into your Gainful hydration or drink of choice.",
        tape: ["5g Creatine", "0 Calories"],
        qty: (_jsxs("span", { children: ["28 servings", _jsx("br", {}), "per container"] })),
        howToUse: "Mix 1 scoop of Creatine into your Gainful Hydration or drink of choice. Consume daily to see the best results.",
    },
    [FIBER]: {
        bullets: [
            "5g of dietary fiber",
            "supports regularity, gut health, satiety, and nutrient absorption",
            "formulated with a scientist-recommended dosage of beta glucan",
        ],
        carouselDesktop: fiberDesktop,
        carouselMobile: fiberMobile,
        img: Fiber,
        hed: "Oat Bran Fiber",
        eyebrow: "Formula Boost",
        dek: "Fiber is a supplement that supports regularity, gut health, satiety, and nutrient absorption. Ours is formulated with a scientist-recomended dosage of beta glucan — a heart-healthy soluable fiber derived from oats",
        tape: ["5g Oat Bran", "2g Protein"],
        qty: (_jsxs("span", { children: ["14 servings", _jsx("br", {}), "per container"] })),
        howToUse: "Mix 1 scoop of fiber into your coffee, tea, or Gainful Protein Powder. Consume daily for the best results.",
    },
    [GREENS]: {
        bullets: [
            "Includes 11 organic fruits and vegetables",
            "Supports your gut microbiome and enhances nutrient absorption",
            "Enhance mental strength with a blend of powerful adaptogens",
        ],
        carouselDesktop: [],
        carouselMobile: [],
        carouselDesktopByFlavor: {
            [LEMONGINGER]: greensLemonGingerDesk,
            [PINEAPPLE]: greensTropicalPineappleDesk,
        },
        carouselMobileByFlavor: {
            [LEMONGINGER]: greensLemonGingerMobile,
            [PINEAPPLE]: greensTropicalPineappleMobile,
        },
        img: Greens,
        hed: "Daily Performance Greens",
        eyebrow: "",
        dek: "Delicious and powerful, these individually-packed servings of greens will transform your daily routine.  Our performance greens are packed with phytonutrients and adaptogens from whole food ingredients that nurture your gut microbiome, immune system, cognitive function and overall health.",
        tape: ["30 calories per serving", "0 Grams of sugar"],
        qty: _jsx("span", { children: "28 on-the-go packs" }),
        howToUse: "Pour 1 pack of Greens into water. For a lighter flavor, use 10-12oz of water. \n\nFor a bolder flavor, use 8-9oz of water. Shake, stir, or blend to combine. Settling may naturally occur.\n\n Drink immediately, or shake before enjoying. Best served ice cold.",
    },
};
//container types
export const containerType = {
    [PROTEIN]: { singular: "bag", plural: "bags" },
    [HYDRATION]: { singular: "bag", plural: "bags" },
    [PREWORKOUT]: { singular: "jar", plural: "jars" },
    [CREATINE]: { singular: "jar", plural: "jars" },
    [COLLAGEN]: { singular: "jar", plural: "jars" },
    [FIBER]: { singular: "jar", plural: "jars" },
    [GREENS]: { singular: "box", plural: "boxes" },
};
// questions
export const questionOptions = {
    [PROTEIN]: [
        {
            type: SELECTOR,
            title: "Select a base",
            maxChoices: 1,
            name: "PROTEIN_BASE",
            tooltip: "protein_base",
            subhed: "Choose a protein base that supports your dietary needs and preferences",
            options: [
                {
                    hed: "Whey Based",
                    // subHed1: "Whey concentrate",
                    // subHed2: "Whey isolate",
                    value: WHEY_BASED,
                },
                {
                    hed: "Plant Based",
                    // subHed1: "Pea Protein",
                    // subHed2: "Organic rice protein",
                    value: PLANT_BASED,
                },
                {
                    hed: "Low Lactose",
                    // subHed1: "Ingredient 1",
                    // subHed2: "Ingredient 2",
                    value: LOW_LACTOSE,
                },
                {
                    hed: "Ketogenic",
                    // subHed1: "Ingredient 1",
                    // subHed2: "Ingredient 2",
                    value: KETOGENIC,
                },
            ],
        },
        {
            type: SELECTOR,
            title: "Pick a goal boost",
            subhed: "Make a selection that best aligns with your goals",
            maxChoices: 1,
            name: "GOAL_BOOST",
            tooltip: "protein_goal_boost",
            options: [
                {
                    hed: "Lose Weight",
                    value: LOSE_WEIGHT,
                },
                {
                    hed: "Gain Weight",
                    value: GAIN_WEIGHT,
                },
                {
                    hed: "Build Muscle",
                    value: BUILD_MUSCLE,
                },
            ],
        },
        {
            type: FLAVOR_BOOST_PICKER,
            title: "Choose 2 flavor boost packs",
            subhed: "Switch up your flavor daily with our single serve flavor packets (1 flavor pack includes 7 single packets)",
            tooltip: "protein_flavor",
        },
    ],
    [HYDRATION]: [
        {
            type: SELECTOR,
            title: "Select Flavor",
            maxChoices: 1,
            name: "FLAVOR",
            variant: "flavor",
            options: [
                {
                    hed: "Tropical Mango",
                    image: ThumbMango,
                    value: MANGO,
                },
                {
                    hed: "Strawberry Lemonade",
                    image: ThumbSL,
                    value: SL,
                },
                {
                    hed: "Lemon Lime",
                    image: ThumbLL,
                    value: LL,
                },
            ],
        },
        {
            type: SELECTOR,
            title: "Select Caffeine Level",
            subhed: "Select your hydration caffeine preference",
            tooltip: "hydration_caffeine",
            name: "CAFFEINE",
            options: [
                {
                    hed: "Caffeinated",
                    value: CAF,
                },
                {
                    hed: "Non-caffeinated",
                    value: DECAF,
                },
            ],
        },
        {
            type: SELECTOR,
            title: "Select Sweat Level",
            subhed: "Select your sweat level on a typical day",
            tooltip: "hydration_sweat",
            name: "SWEAT",
            options: [
                {
                    hed: "A Little Sweaty",
                    value: LOW_SWEAT,
                },
                {
                    hed: "Super Sweaty",
                    value: HIGH_SWEAT,
                },
            ],
        },
    ],
    [PREWORKOUT]: [
        {
            type: SELECTOR,
            title: "Select Flavor",
            maxChoices: 1,
            name: "FLAVOR",
            variant: "flavor",
            options: [
                {
                    hed: "Watermelon",
                    image: ThumbWatermelon,
                    value: WATERMELON,
                },
                {
                    hed: "Strawberry Lemonade",
                    image: ThumbSL,
                    value: SL,
                },
            ],
        },
        {
            type: SELECTOR,
            title: "Select Caffeine Level",
            subhed: "Select your pre-workout caffeine preference",
            tooltip: "preworkout_caffeine",
            name: "CAFFEINE",
            options: [
                {
                    hed: "Caffeinated",
                    value: CAF,
                },
                {
                    hed: "Non-caffeinated",
                    value: DECAF,
                },
            ],
        },
        {
            type: SELECTOR,
            title: "Select Intensity Level",
            subhed: "Select your typical workout intensity to customize your stimulant levels",
            tooltip: "preworkout_stim",
            name: "STIM_LEVEL",
            variant: "long",
            options: [
                {
                    hed: "Moderate Intensity",
                    value: LOW_STIM,
                },
                {
                    hed: "Moderate Intensity + Creatine",
                    value: MED_STIM,
                },
                {
                    hed: "High Intensity + Creatine",
                    value: HIGH_STIM,
                },
            ],
        },
    ],
    [GREENS]: [
        {
            type: SELECTOR,
            title: "Select Flavor",
            maxChoices: 1,
            name: "FLAVOR",
            variant: "flavor",
            options: [
                {
                    hed: "Lemon Ginger",
                    image: ThumbLemonGinger,
                    value: LEMONGINGER,
                },
                {
                    hed: "Tropical Pineapple",
                    image: ThumbPineapple,
                    value: PINEAPPLE,
                },
            ],
        },
    ],
};
// logic for picking sku
export const decideVersion = (type, values) => {
    let key;
    switch (type) {
        case COLLAGEN:
            return "collagen";
        case FIBER:
            return "fiber";
        case CREATINE:
            return "creatine";
        case PROTEIN:
            key = [values[PROTEIN].PROTEIN_BASE, values[PROTEIN].GOAL_BOOST].join("+");
            return proteinMap[key];
        case HYDRATION:
            key = [
                values[HYDRATION].FLAVOR,
                values[HYDRATION].SWEAT,
                values[HYDRATION].CAFFEINE,
            ].join("+");
            return hydrationMap[key];
        case PREWORKOUT:
            key = [
                values[PREWORKOUT].FLAVOR,
                values[PREWORKOUT].STIM_LEVEL,
                values[PREWORKOUT].CAFFEINE,
            ].join("+");
            return preworkoutMap[key];
        case GREENS:
            key = values[GREENS].FLAVOR;
            return greensMap[key];
        default:
    }
};
export const prettifyOption = (opt) => {
    const map = {
        [HIGH_STIM]: "High Stim",
        [LOW_STIM]: "Low Stim",
        [MED_STIM]: "Med Stim",
        [CAF]: "Caffeinated",
        [DECAF]: "Non-caffeinated",
        [HIGH_SWEAT]: "High Sweat",
        [LOW_SWEAT]: "Low Sweat",
        [PLANT_BASED]: "Plant-based",
        [WHEY_BASED]: "Whey-based",
        [LOW_LACTOSE]: "Low Lactose",
        [KETOGENIC]: "Keto",
        [LOSE_WEIGHT]: "Lose Weight",
        [GAIN_WEIGHT]: "Gain Weight",
        [BUILD_MUSCLE]: "Build Muscle",
    };
    return map[opt];
};
const mapValuesToObject = (keyArray, answerArray) => {
    const vals = {};
    keyArray.forEach((x, i) => {
        vals[x] = answerArray[i];
    });
    return vals;
};
const getSkuFromMap = (map, sku) => {
    return Object.keys(map).find((str) => map[str] === sku);
};
const setValuesFromString = (type, str) => {
    const answerArray = str.split("+");
    switch (type) {
        case PROTEIN:
            return mapValuesToObject(["PROTEIN_BASE", "GOAL_BOOST"], answerArray);
        case PREWORKOUT:
            return mapValuesToObject(["FLAVOR", "STIM_LEVEL", "CAFFEINE"], answerArray);
        case HYDRATION:
            return mapValuesToObject(["FLAVOR", "SWEAT", "CAFFEINE"], answerArray);
        case GREENS:
            return mapValuesToObject(["FLAVOR"], answerArray);
        default:
            return {};
    }
};
// assumes that the answer-to-sku mapping is one-to-one
const getStringFromSku = (type, sku) => {
    switch (type) {
        case PROTEIN:
            return getSkuFromMap(proteinMap, sku);
        case HYDRATION:
            return getSkuFromMap(hydrationMap, sku);
        case PREWORKOUT:
            return getSkuFromMap(preworkoutMap, sku);
        case GREENS:
            return getSkuFromMap(greensMap, sku);
        default:
            return "";
    }
};
export const DEFAULT = {
    [PROTEIN]: {
        PROTEIN_BASE: WHEY_BASED,
        GOAL_BOOST: LOSE_WEIGHT,
        FLAVORS: {
            variety: 2,
        },
    },
    [HYDRATION]: {
        FLAVOR: MANGO,
        CAFFEINE: CAF,
        SWEAT: LOW_SWEAT,
    },
    [PREWORKOUT]: {
        FLAVOR: WATERMELON,
        CAFFEINE: CAF,
        STIM_LEVEL: MED_STIM,
    },
    [GREENS]: {
        FLAVOR: LEMONGINGER,
    },
};
export const hydrateValuesFromSku = (type, sku) => {
    const newValues = structuredClone(DEFAULT);
    const mapKey = getStringFromSku(type, sku);
    // @ts-ignore
    // i dont want to learn how to reconcile these types right now
    // and dont have enough time. i'm replacing a subtree
    newValues[type] = setValuesFromString(type, mapKey || "");
    return newValues;
};
